export const calculateMargin = (cost: number, retail: number) =>
  retail > 0 ? (retail - cost) / retail : 0;

export const calculateMarkup = (cost: number, retail: number) =>
  cost > 0 ? (retail - cost) / cost : 0;
